import Pagination from "../../../screens/Common/Pagination";
import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import { withApollo } from "react-apollo";
import DisplayErrors from "../../Common/DisplayErrors";
import { getListofMessageMaster } from "../../../services/graphql/queries/messageConfiguration";
import { Link } from "react-router-dom";
import { PAGINATION_OFFSET_VALUE } from "../../../constants/app-constants";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
import NotAccessible from "../../Common/NotAccessible";
import React from "react";
import view from "../../../static/images/svg/view.svg";
class MessageConfigurationList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageList: [],
      errors: [],
      error: "",
      loading: true,
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      accessSpecifier: {},
      accessSpecifierLoading: true,
      Message_Configuration_Feature_ID: 174,
      Message_Configuration_Module_ID: 6,
    };
    this.getData = this.getData.bind(this);
    this.fetchAccessSpecifier = this.fetchAccessSpecifier.bind(this);
  }
  getData() {
    this.props.client
      .query({
        query: getListofMessageMaster,
        variables: {
          noOfRows: this.state.offset,
          offset: this.state.currentPage,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const messageList = result.data.getListofMessageMaster;
        this.initialState = {
          pageOfItems: messageList,
        };
        this.setState({ ...this.initialState, loading: false, error: "" });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }
  fetchAccessSpecifier() {
    this.setState({
      loading: true,
    });
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: this.state.Message_Configuration_Module_ID,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        if (Object.keys(response).length != 0) {
          this.setState({
            accessSpecifier:
              response[this.state.Message_Configuration_Feature_ID],
            accessSpecifierLoading: false,
          });
          this.getData();
        } else {
          this.setState({
            accessSpecifierLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
          accessSpecifierLoading: false,
        });
      });
  }
  onChangePage(currentPage) {
    console.log("page", currentPage);
    this.state.currentPage = currentPage;
    this.state.pageOfItems = [];

    this.getData();
  }
  componentDidMount() {
    this.setState({ loading: true });
    this.fetchAccessSpecifier();
  }
  render() {
    const messageList = this.state.pageOfItems;
    const {
      error,
      loading,
      accessSpecifierLoading,
      accessSpecifier,
    } = this.state;
    return (
      <>
        {accessSpecifier && accessSpecifier.viewP ? (
          <>
            <div>
              {/* Breadcrumb Section End */}
              <div className="row align-items-center no-gutters">
                <div className="col-md-6">
                  <h1 className="heading m-b-0">Configured Messages</h1>
                </div>
              </div>
              {/* Table Section Start */}
              <div className="table-responsive">
                <table className="table table-style-1">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th scope="col">DESCRIPTION</th>
                      <th>ACTION(s)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {messageList && messageList.length
                      ? messageList.map((data, index) => {
                          return (
                            // <Link
                            //   to={`/messageConfiguration-profile?id=${data.Id}`}
                            // >
                            <tr key={index}>
                              <td>{data.Id}</td>
                              <td
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title={data.description}
                              >
                                {data.description.substring(0, 40)}
                              </td>
                              <td id="td1">
                                <a
                                  href={`/messageConfiguration-profile?id=${data.Id}`}
                                  className="link-primary"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="View"
                                >
                                  <img src={view} />
                                </a>
                              </td>
                            </tr>
                            // </Link>
                          );
                        })
                      : null}
                  </tbody>
                </table>
                {!messageList.length && error ? <div>{error}</div> : null}
                {!messageList.length && loading ? <div>Fetching...</div> : null}
                {!messageList.length && !error && !loading ? (
                  <div style={{ textAlign: "center" }}>No Data</div>
                ) : null}
                <Pagination
                  loading={loading}
                  items={messageList}
                  pageSize={this.state.offset}
                  initialPage={this.state.currentPage}
                  onChangePage={this.onChangePage.bind(this)}
                />
              </div>
            </div>
          </>
        ) : accessSpecifierLoading ? (
          <div>Fetching...</div>
        ) : (
          <NotAccessible />
        )}
      </>
    );
  }
}

export default withApollo(MessageConfigurationList);
